import { Injectable } from '@angular/core';
import { AlertService } from './alerts.service';
import {BackendApiService} from "./backend-api.service";

@Injectable({
    providedIn: 'root'
})
export class UserPermissionsService {
    private permissions: { component: string, name: string}[] = [];
    private user?: User;

    constructor(
        private backendApiService: BackendApiService,
        private alertService: AlertService,
    ) {}

    loadPermissions() {
        return this.backendApiService.get('/user')
            .toPromise()
            .then(response => {
                if (response) {
                    this.permissions = response.permissions;
                    this.user = response.user;
                } else {
                    // Handle the scenario where response is undefined
                    console.warn('Received undefined response when trying to fetch permissions.');
                }

                return response;
            })
            .catch(error => {
                //this.alertService.alertError('Permission denied. Please contact the administrator.');
            });
    }


    hasPermission(permissionName: string): boolean {
        if (this.user?.is_admin) {
            return true;
        }
        return this.permissions.some(permission => permission.name === permissionName);
    }

    hasComponentPermission(permissionName: string): boolean {
        if (this.user?.is_admin) {
            return true;
        }
        return this.permissions.some(permission => permission.component === permissionName);
    }

    getUserDetails() {
        return new Promise<User>((resolve, reject) => {
            if (this.user) {
                return resolve(Object.assign({}, this.user));
            }

            let interval = setInterval(() => {
                if (this.user) {
                    clearInterval(interval);
                    resolve(Object.assign({}, this.user));
                }
            }, 100);
        });
    }
}

export interface User {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    'pic-internal'?: string;
    language: string;
    is_admin: boolean;
    default_dashboard_id: number;
    insights_viewer?: boolean;  // listed in users.user_insights_viewers (PD-5907)
}
